// Service Worker 登録（要望#206 / §18 TA-3・PWA化の器）
// - SW 非対応環境（insecure origin では navigator.serviceWorker 自体が生えない）では no-op
// - 失敗してもアプリ本体を止めない（console.warn のみ）
// - push 購読（PushManager.subscribe / VAPID）は Push 基盤（要望#205）が本モジュールの
//   getServiceWorkerRegistration() を使って行う想定（ここでは購読しない）

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  const register = () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('[pwa] Service Worker の登録に失敗:', err));
  };
  // render 後に呼ばれるため load が既に済んでいるケースを取りこぼさない
  if (document.readyState === 'complete') {
    register();
  } else {
    window.addEventListener('load', register, { once: true });
  }

  // 新しい SW が有効化されたとき（= 新バージョンのデプロイ後）にバナー表示用イベントを発火する。
  // skipWaiting() により SW 交代は即座に起きる。controllerchange は SW 交代を確実に捉える。
  // 初回登録時（controller が null→有効な SW へ）は無視し、更新時のみ発火させる。
  let prevController = navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (prevController !== null) {
      window.dispatchEvent(new CustomEvent('konecco-sw-updated'));
    }
    prevController = navigator.serviceWorker.controller;
  });
}

// #205（Push通知基盤）への口：購読時に registration を取得する
export async function getServiceWorkerRegistration(): Promise<ServiceWorkerRegistration | undefined> {
  if (!('serviceWorker' in navigator)) return undefined;
  try {
    return await navigator.serviceWorker.ready;
  } catch {
    return undefined;
  }
}

// アプリ表示時にホーム画面バッジをクリアする（app-layout から呼ぶ）
// ブラウザ側 API + SW 側カウンタの両方をリセット。
export function clearAppBadge(): void {
  if ('clearAppBadge' in navigator) {
    (navigator as Navigator & { clearAppBadge(): Promise<void> }).clearAppBadge().catch(() => {});
  }
  navigator.serviceWorker?.ready
    .then((reg) => reg.active?.postMessage({ type: 'konecco-badge-clear' }))
    .catch(() => {});
}
